import { soundUrl, volumeToGain, getSoundFile } from './constants';

export class AudioManager {
    constructor(volume = 100) {
        this.volume = volume;
        this.audios = new Map();
        this.currentAudio = null;
        this.unlocked = false;
    }

    setVolume(volume) {
        this.volume = volume;
        const gain = volumeToGain(volume);
        this.audios.forEach((audio) => {
            audio.volume = gain;
        });
    }

    async unlock() {
        if (this.unlocked) return;
        try {
            // Create a short silent buffer to unlock the audio context on mobile
            const audio = this._getAudio('nic');
            audio.volume = 0;
            await audio.play();
            audio.pause();
            audio.currentTime = 0;
        } catch {
            // ignore
        } finally {
            this.unlocked = true;
        }
    }

    _getAudio(file) {
        if (!this.audios.has(file)) {
            const audio = new Audio(soundUrl(file));
            audio.volume = volumeToGain(this.volume);
            this.audios.set(file, audio);
        }
        return this.audios.get(file);
    }

    async play(category, index) {
        const file = getSoundFile(category, index);
        if (!file || file === 'nic') return;

        if (!this.unlocked) {
            await this.unlock();
        }

        if (this.currentAudio) {
            this.currentAudio.pause();
            this.currentAudio.currentTime = 0;
        }

        const audio = this._getAudio(file);
        audio.volume = volumeToGain(this.volume);
        audio.currentTime = 0;
        this.currentAudio = audio;

        try {
            await audio.play();
        } catch {
            // ignore autoplay errors
        }
    }

    stop() {
        if (this.currentAudio) {
            this.currentAudio.pause();
            this.currentAudio.currentTime = 0;
            this.currentAudio = null;
        }
    }

    preview(file) {
        if (!file || file === 'nic') return;
        const audio = this._getAudio(file);
        audio.currentTime = 0;
        audio.volume = volumeToGain(this.volume);
        audio.play().catch(() => {});
    }
}

export default AudioManager;
